import { Directive, ElementRef, Input, OnInit, OnChanges, Renderer2 } from '@angular/core';

@Directive({ selector: '[image-pick]' })
export class ImagePick implements OnInit {

    @Input('image-pick') imageArray: Array<any> = [];
    @Input() name: string;
    @Input() size: string;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        if (!this.el.nativeElement.nodeName || this.el.nativeElement.nodeName.toLowerCase() !== 'img' || this.imageArray.length < 1) {
            return
        }

        let image = this.imageArray.find((i) => { return this.name === i.name || this.size === i.size });
        if (image) {
            this.el.nativeElement.src = image.url;
        }
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/image-pick.directive.ts